<template>
  <div class="customer_service_home">
    <div class="home_online">
      <div class="inner">
        <a
          class="blink1"
          href="javascript:;"
          target="_self"
          @click="_openCustomerService"
        >
          点击联系客服
        </a>
        <p class="p1">服务时间 10:00-20:00</p>
      </div>
    </div>
    <div class="home_question">
      <div class="inner">
        <a
          class="blink1"
          href="javascript:;"
          target="_self"
          @click="_openCustomerService"
        >
          点击提交工单
        </a>
        <a
          class="blink2"
          href="javascript:;"
          target="_self"
          @click="_openCustomerService"
        >
          点击查看工单回复
        </a>
      </div>
    </div>
    <div class="home_vip">
      <div class="inner">
        <template v-if="userLevel.level >= 5">
          <p class="p1">QQ：2853515169</p>
          <p class="p1">服务时间 09:00-18:00</p>
          <p class="p1 font12" style="width: 440px;">
            （注：为保障服务质量，未获得专属服务的用户将不会通过好友，请您谅解！）
          </p>
        </template>
        <template v-else>
          <p class="p1">VIP专享</p>
        </template>
      </div>
    </div>
    <div class="home_rule">
      <div class="inner">
        <a class="blink1" href="https://wan.xunlei.com/rules" target="_blank">
          点击查看玩家守则详情
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { openCustomerService } from '~/utils/util'
export default {
  data() {
    return {
      userLevel: {}
    }
  },
  mounted() {},
  methods: {
    clientCreated() {
      this.fetchUserLevel()
    },
    fetchUserLevel() {
      this.$request('queryUserLevel').then((data = {}) => {
        this.userLevel = data
      })
    },
    _openCustomerService() {
      openCustomerService()
    }
  }
}
</script>
